import React from 'react'
import { Grid, Box } from '@mui/material'
import Countdown, { CountdownRenderProps } from 'react-countdown'
import clsx from 'clsx'
import { str } from '../../utils'

const Renderer: React.FC<CountdownRenderProps & { classes: any }> = ({ days, hours, minutes, seconds, classes }) => {
  const format = (num: number): string[] => num.toString().padStart(2, '0').split('')

  return (
    <Grid container wrap="nowrap" justifyContent="center" alignItems="center" spacing={0}>
      <Grid item>
        <Box className={clsx(classes.num, classes.ml)}>{format(days)[0]}</Box>
        <Box className={classes.num}>{format(days)[1]}</Box>
        <Box className={classes.boxDots} />
        <Box className={clsx(classes.titleСount, classes.ml)}>{str.declOfNum(days, ['День', 'Дня', 'Дней'])}</Box>
      </Grid>

      <Grid item>
        <Box className={classes.num}>{format(hours)[0]}</Box>
        <Box className={classes.num}>{format(hours)[1]}</Box>
        <Box className={classes.boxDots}>
          <Box>
            <Box id="dots3" className={classes.dots} />
            <Box id="dots4" className={classes.dots} />
          </Box>
        </Box>
        <Box className={classes.titleСount}>{str.declOfNum(hours, ['Час', 'Часа', 'Часов'])}</Box>
      </Grid>

      <Grid item>
        <Box className={classes.num}>{format(minutes)[0]}</Box>
        <Box className={classes.num}>{format(minutes)[1]}</Box>
        <Box className={classes.boxDots}>
          <Box>
            <Box id="dots5" className={classes.dots} />
            <Box id="dots6" className={classes.dots} />
          </Box>
        </Box>
        <Box className={classes.titleСount}>{str.declOfNum(minutes, ['Минута', 'Минуты', 'Минут'])}</Box>
      </Grid>

      <Grid item>
        <Box className={classes.num}>{format(seconds)[0]}</Box>
        <Box className={clsx(classes.num, classes.mr)}>{format(seconds)[1]}</Box>
        <Box className={clsx(classes.titleСount, classes.mr)}>
          {str.declOfNum(seconds, ['Секунда', 'Секунды', 'Секунд'])}
        </Box>
      </Grid>
    </Grid>
  )
}

export const TimerStart: React.FC<{ classes: any; timeEnd: number }> = ({ classes, timeEnd = 0 }) => {
  return (
    <Countdown
      date={timeEnd}
      renderer={(props) => <Renderer classes={classes} {...props} />}
      onComplete={() => window.location.reload()}
    />
  )
}
